import * as fromReducer from './integrated-ireckon-hotel.reducer';
import * as fromState from './integrated-ireckon-hotel.state';

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { LocationsRouterStoreSelectors } from '../router';

export const selectIntegratedIReckonHotelState =
  createFeatureSelector<fromState.IntegratedIReckonHotelState>('integratedIReckonHotel');

export const selectIntegratedIReckonHotelIds = createSelector(
  selectIntegratedIReckonHotelState,
  fromReducer.selectIntegratedIReckonHotelIds
);

export const selectIntegratedIReckonHotelEntities = createSelector(
  selectIntegratedIReckonHotelState,
  fromReducer.selectIntegratedIReckonHotelEntities
);

export const selectAllIntegratedIReckonHotels = createSelector(
  selectIntegratedIReckonHotelState,
  fromReducer.selectAllIntegratedIReckonHotels
);

export const selectIntegratedIReckonHotelById = createSelector(
  LocationsRouterStoreSelectors.selectLocationId,
  selectIntegratedIReckonHotelEntities,
  (locationUniqueId, entities) => {
    return entities[locationUniqueId];
  }
);
